// IMPORTANT: Do not add more languages without platform approval.
// This platform officially supports ONLY English and Hindi.

export type Language = 'en' | 'hi';

export const translations = {
  en: {
    // Common
    app_name: 'VLE Plus',
    dashboard: 'Dashboard',
    sales: 'Sales',
    expenses: 'Expenses',
    reports: 'Reports',
    settings: 'Settings',
    logout: 'Logout',
    login: 'Login',
    signup: 'Sign Up',
    email: 'Email',
    password: 'Password',
    full_name: 'Full Name',
    phone: 'Phone',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    search: 'Search',
    filter: 'Filter',
    export: 'Export',
    print: 'Print',
    download: 'Download',
    share: 'Share',
    loading: 'Loading...',
    no_data: 'No data available',
    
    // Auth
    welcome_back: 'Welcome Back',
    create_account: 'Create Account',
    login_subtitle: 'Enter your credentials to access your account',
    signup_subtitle: 'Create your business account to get started',
    business_name: 'Business Name',
    already_have_account: 'Already have an account?',
    dont_have_account: "Don't have an account?",
    forgot_password: 'Forgot password?',
    
    // Dashboard
    todays_sales: "Today's Sales",
    todays_expenses: "Today's Expenses",
    pending_payments: 'Pending Payments',
    total_profit: 'Total Profit',
    quick_actions: 'Quick Actions',
    add_new_sale: 'Add New Sale',
    add_new_expense: 'Add New Expense',
    generate_report: 'Generate Report',
    recent_transactions: 'Recent Transactions',
    sales_vs_expenses: 'Sales vs Expenses',
    view_all: 'View All',
    
    // Sidebar
    dailyBook: 'Daily Book',
    kioskBook: 'Kiosk Book',
    setuManagement: 'Setu Management',
    pikVima: 'Pik Vima',
    daily_book: 'Daily Book',
    kiosk_book: 'Kiosk Book',
    setu_book: 'Setu/CSC Book',
    setu_management: 'Setu Management',
    pik_vima: 'Pik Vima',
    services: 'Services',
    customers: 'Customers',
    users: 'Users',
    subscription: 'Subscription',
    docSlip: 'Doc Slip',
    
    // Mobile Nav
    more: 'More',
    menu: 'Menu',
    
    // Roles - Updated for SaaS terminology
    platform_admin: 'Platform Admin',
    super_admin: 'Business Owner',
    admin: 'Manager',
    operator: 'Staff',
    business_owner: 'Business Owner',
    staff: 'Staff',
    
    // Time filters
    today: 'Today',
    this_week: 'This Week',
    this_month: 'This Month',
    custom: 'Custom',
    
    // Payment modes
    cash: 'Cash',
    upi: 'UPI',
    bank: 'Bank Transfer',
    online: 'Online',
    
    // Status
    paid: 'Paid',
    unpaid: 'Unpaid',
    partial: 'Partial',
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
  },
  hi: {
    // Common
    app_name: 'VLE Plus',
    dashboard: 'डैशबोर्ड',
    sales: 'बिक्री',
    expenses: 'खर्च',
    reports: 'रिपोर्ट',
    settings: 'सेटिंग्स',
    logout: 'लॉग आउट',
    login: 'लॉग इन',
    signup: 'साइन अप',
    email: 'ईमेल',
    password: 'पासवर्ड',
    full_name: 'पूरा नाम',
    phone: 'फ़ोन',
    save: 'सहेजें',
    cancel: 'रद्द करें',
    delete: 'हटाएं',
    edit: 'संपादित करें',
    add: 'जोड़ें',
    search: 'खोजें',
    filter: 'फ़िल्टर',
    export: 'निर्यात',
    print: 'प्रिंट',
    download: 'डाउनलोड',
    share: 'शेयर',
    loading: 'लोड हो रहा है...',
    no_data: 'कोई डेटा उपलब्ध नहीं',
    
    // Auth
    welcome_back: 'वापस स्वागत है',
    create_account: 'खाता बनाएं',
    login_subtitle: 'अपने खाते में लॉग इन करने के लिए अपना विवरण दर्ज करें',
    signup_subtitle: 'शुरू करने के लिए अपना व्यवसाय खाता बनाएं',
    business_name: 'व्यवसाय का नाम',
    already_have_account: 'क्या आपके पास पहले से खाता है?',
    dont_have_account: 'खाता नहीं है?',
    forgot_password: 'पासवर्ड भूल गए?',
    
    // Dashboard
    todays_sales: 'आज की बिक्री',
    todays_expenses: 'आज के खर्च',
    pending_payments: 'बकाया भुगतान',
    total_profit: 'कुल लाभ',
    quick_actions: 'त्वरित कार्य',
    add_new_sale: 'नई बिक्री जोड़ें',
    add_new_expense: 'नया खर्च जोड़ें',
    generate_report: 'रिपोर्ट बनाएं',
    recent_transactions: 'हाल के लेनदेन',
    sales_vs_expenses: 'बिक्री बनाम खर्च',
    view_all: 'सभी देखें',
    
    // Sidebar
    dailyBook: 'दैनिक बुक',
    kioskBook: 'कियोस्क बुक',
    setuManagement: 'सेतु प्रबंधन',
    pikVima: 'पिक विमा',
    daily_book: 'दैनिक बुक',
    kiosk_book: 'कियोस्क बुक',
    setu_book: 'सेतु/CSC बुक',
    setu_management: 'सेतु प्रबंधन',
    pik_vima: 'पिक विमा',
    services: 'सेवाएं',
    customers: 'ग्राहक',
    users: 'उपयोगकर्ता',
    subscription: 'सदस्यता',
    docSlip: 'दस्तावेज़ स्लिप',
    
    // Mobile Nav
    more: 'और',
    menu: 'मेन्यू',
    
    // Roles - Updated for SaaS terminology
    platform_admin: 'प्लेटफ़ॉर्म एडमिन',
    super_admin: 'व्यवसाय मालिक',
    admin: 'प्रबंधक',
    operator: 'स्टाफ',
    business_owner: 'व्यवसाय मालिक',
    staff: 'स्टाफ',
    
    // Time filters
    today: 'आज',
    this_week: 'इस सप्ताह',
    this_month: 'इस महीने',
    custom: 'कस्टम',
    
    // Payment modes
    cash: 'नकद',
    upi: 'UPI',
    bank: 'बैंक ट्रांसफर',
    online: 'ऑनलाइन',
    
    // Status
    paid: 'भुगतान किया',
    unpaid: 'अवैतनिक',
    partial: 'आंशिक',
    pending: 'लंबित',
    approved: 'अनुमोदित',
    rejected: 'अस्वीकृत',
  },
} as const;

export type TranslationKey = keyof typeof translations.en;
